export default "__VITE_ASSET__DE7Yzrnl__"